import Login from "../pages/authpages/login/login";
import NewPass from "../pages/authpages/newpassword/newpass";
import Signup from "../pages/authpages/signup/signup";
import PaymentSubscriptions from "../pages/PaymentSubscriptions/PaymentSubscriptions";
import Manageplanfree from "../pages/manageplanfree/manageplanfree";
import Loglayout from "../componenet/loglayout";
import Forgetotp from "../pages/authpages/forgetotp/forgetotp";
import Terms from "../pages/termofservice/terms";
import Privacypolicy from "../pages/privacypolicy/privacypolicy";
import QuizGenerator from "../pages/dashboard pages/quiz generator/quizgenerator";
import ProfilePage from "../pages/dashboard pages/profile-page/profilepage";
import SettingsPage from "../pages/dashboard pages/settings-page/settingspage";
import Home from "../pages/dashboard pages/home/home";
import Forgotpage from '../pages/authpages/forgot/forgotpage';
import Pagenotfound from "../componenet/Pagenotfound";
import ProtectedRoute from "./Protectedroute";
import Success from "../pages/authpages/success/success";
import Card from "../pages/manageplanfree/Card";
import Plandetails from "../pages/dashboard pages/plandetails/plandetails";
import Quizpage from "../pages/dashboard pages/Quiz-page/quizpage";
import Quizquestion from "../pages/dashboard pages/Quiz-page/Quizquestion"
import ViewHistory from "../pages/dashboard pages/View-history/Viewhistory";
import Feedback from "../pages/feedback/modal/feedback"

const pagesData = [

  {
    path: "/",
    element: <Loglayout><Login /></Loglayout>,
  },
  {
    path: "/signup",
    element: <Loglayout><Signup /></Loglayout>,
  },
  {
    path: "/newpassword",
    element: <Loglayout><NewPass /></Loglayout>,
  },
  {
    path: "/forgot",
    element: <Loglayout><Forgotpage /></Loglayout>,
  },
  {
    path: "/success",
    element: <Success />,
  },
  {
    path: "/paymentsubscription",
    element: <PaymentSubscriptions />,
  },
  {
    path: "/manageplanfree",
    element: <Manageplanfree />,
  },
  {
    path: "/verifyotp",
    element: <Loglayout><Forgetotp /></Loglayout>,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: '/privacy',
    element: <Privacypolicy />
  },

  {
    path: "/dashboard",
    element: <ProtectedRoute Component={Home} />,
  },
  {
    path: '/quizz',
    element: <ProtectedRoute Component={Quizpage} />,
  },
  {
    path: "/history",
    element: <ProtectedRoute Component={ViewHistory} />,
  },
  {
    path: "/profile",
    element: <ProtectedRoute Component={ProfilePage} />,
  },
  {
    path: "/settings",
    element: <ProtectedRoute Component={SettingsPage} />
  },
  {
    path: "/quizgenerator",
    element: <ProtectedRoute Component={QuizGenerator} />,
  },
  {
    path: "/manage-plan",
    element: <Manageplanfree />,
  },
  {
    path: "/plan-details",
    element: <Plandetails />,
  },

  {
    path: "/card",
    element: <Card />,
  },
  {
    path: "/quizquestion",
    element: <ProtectedRoute Component={Quizquestion} />
  },
  {
    path: "/feedback",
    element: <Feedback />,
  },
  {
    path: "*",
    element: <Pagenotfound />,
  },


];

export default pagesData;
